import { Card } from '@/shared/types/card';
import { CardInfoChangedAction } from '@/shared/actions/card';
import { CARD_INFO_CHANGED } from '@/shared/constants/action-types';


type State = {
    card: Card
    loading: boolean
}

const initialState: State = {
    card  : {
        cardHolder: '',
        cardNumber: '',
        cardExpiration: '',
        cvc: '',
    },
    loading: false,
};


export const card = (state = initialState, action: CardInfoChangedAction) => {
    switch (action.type) {
        case CARD_INFO_CHANGED: {
            const { value, name } = action.payload;
            const newState = { ...state };
            newState.card[name] = value;
            return newState;
        }
        default: return state;
    }
};
